import React, { useEffect } from "react";
import API from "../../helpers/API";
import Login from "../../login/components/Login";
import { SESSION_HEARTBEAT } from "../constants/endpoints";
import AdminUserNav from "../../usermanagement/AdminUserNav";
import { useDispatch } from "react-redux";
import { SET_USER_SESSION } from "../constants/ActionTypes";
import AdminUserNavcp from "../../usermanagement/AdminUserNavcp";
import { handleError } from "../actions/commonActions";

const OsadminContainer = (props) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  const sessionHeartBeatInterval =
    process.env.REACT_APP_SESSION_HB_INTERVAL || 5;

  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
    const sessionInner = JSON.parse(sessionStorage.getItem("session"));
    if (sessionInner && sessionInner.jwtResponse.token) {
      dispatch({
        type: SET_USER_SESSION,
        payload: sessionInner.jwtResponse.token,
        authData: sessionInner,
      });
    }
  }, [dispatch]);

  setInterval(() => {
    // if (session && session.jwtResponse.token) {
    //   try{
    //     API.patch(
    //       `${SESSION_HEARTBEAT}/${session.userId}`,
    //       {},
    //       { headers: { Authorization: `Bearer ${session.jwtResponse.token}` } }
    //     );
    //   }catch(error){
    //     handleError(error)
    //   }
    // }
    if (session && session.jwtResponse.token) {
      API.patch(
        `${SESSION_HEARTBEAT}/${session.userId}`,
        {},
        { headers: { Authorization: `Bearer ${session.jwtResponse.token}` } }
      )
      .then(response => {
        console.log('Session heartbeat updated:', response.data);
      })
      .catch(error => {
        handleError(error);
        console.error('Error during session heartbeat:', error);
      });
    }
  }, sessionHeartBeatInterval * 60 * 1000);

  if (session && session.jwtResponse.token) {
    const fullName = session.firstName + " " + session.lastName;
    const deaprtmentId = session.deptRoles[0].deptId;
    const roleId = session.deptRoles[0].roleId;
    const roleName = session.roleName;
    return (
      <AdminUserNavcp
        {...props}
        roleName={roleName}
        fullName={fullName}
        deaprtmentId={deaprtmentId}
        roleId={roleId}
      />
    );
  }

  props.history.push("/admin/login");
  return <Login />;
};

export default OsadminContainer;
